<footer class="portal-footer">
  <span class="footer-agency">Oregon Health Authority</span>
  <span>Health Facility Licensing and Certification · Staff portal</span>
  <span class="footer-version">{{environment.build}} · Version {{environment.version}}</span>
</footer>
